
export default {
  props: {
    error: {
      type: Array,
      required: true
    }
  }
};